// extracted by mini-css-extract-plugin
export default {"container":"OnboardingBoxContent_container__t4GnJ"};